import Author from './author';
import BaseModel from './base_model';

// App.Models.Comment
export default BaseModel.extend({
  modelClass: "Comment",
  urlRoot: "/comments",
  wrappedAttributes: {author: Author},
});
